import $ from 'cash-dom';
import Html from "./core/html";
import Sound from "./core/sound";
import EventBus from "./core/event";

export default function initPopup(opts, soundObj) {
    if (WHEEL_SETTINGS) {
        opts = Object.assign({}, WHEEL_SETTINGS, opts || {});
    }
    var form = opts.Wheel.form;
    const Wheel = opts.Wheel;
    const eventBus = new EventBus();
    const html = new Html(eventBus);
    for (let key in opts.sounds) {
        if (key.includes('background')) {
            obj[key] = {
                src: opts.sounds[key],
                sub_type: 'background',
            }
        } else {
            obj[key] = {
                src: opts.sounds[key]
            }
        }
    }
    // init sound
    let sound = soundObj;
    const DEFAULT_SOUND_SETTINGS = {
        background_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.5.14//sounds/cny-background.mp3",
        rolling_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.5.14//sounds/random-pick-8s.mp3",
        button_click_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.5.14//sounds-v2/common/button-click/O-Standard-1.mp3",
        award_audio: "https://cdn.jsdelivr.net/gh/woayst/common@1.5.14//sounds/kids-saying-yay.mp3",
    }
    const soundSettings = SETTINGS && SETTINGS.Sound || DEFAULT_SOUND_SETTINGS;
    if (!sound) {
        let soundConfig = {};
        for (let key in soundSettings) {
            if (key.includes('background')) {
                soundConfig[key] = {
                    src: soundSettings[key],
                    sub_type: 'background',
                }
            } else {
                soundConfig[key] = {
                    src: soundSettings[key]
                }
            }
        }


        if (!opts.no_sound) {
            sound = new Sound(soundConfig);
        } else {
            sound = new Sound(opts.sounds);
        }
    }
    sound.muteAll();

    if (!$('#w-popup-section').length) {
        const popupHTML = `
          <div id="w-popup-section" style="display:none">
            <div id="w-popup-container">
                <button w-role="close_button" class="modal__close w-popup-close-btn" aria-label="Close modal">×</button>
                <button w-role="close_button" class="modal__close w-popup-remove-anim" aria-label="Close modal">×</button>
                <div w-role="close_button" class="w-close-popup-desktop" aria-label="Close modal">
                    <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/arrow-right.png">
                    Đóng popup
                </div>
                <div class="box-game">
                    <div id="vongquaymayman"></div>
                    <button id="w-play-game">Chơi ngay!</button>
                </div>
                <div class="logo-popup w-box-img">
                    <img class="award-image" src="">
                </div>
                <div id="w-popup-userinfo-form">
                    <h4>Bổ sung thông tin</h4>
                    <div w-role="form" class="style-1">
                </div>
                <button id="w-popup-userinfo-form-submit-btn">THỬ ĐỘ MAY MẮN</button>
              </div>
              <div id="w-popup-reward">
                <div class="title-voucher sub-title hide-badluck">Chúc mừng bạn đã trúng</div>
                <div class="title-big title-popup"></div>
                <div class="voucher-content text-tutorial" style="margin-bottom: 10px;">
                </div>
                <div class="input-code copy-code hide-badluck">
                    <input type="text" id="w-text-code" class="code" value="unknow" aria-label="Code Prize" readonly="readonly">
                </div>
                <div class="copy-success">Coupon copied!</div>
                <div id="btn-copy-code" class="btn-copy btn-copy-code hide-badluck" aria-label="Copy mã">Copy mã!</div>
              </div>
            </div>
            <div id="w-popup-close"></div>
          </div>
        `;

        $('body').append(popupHTML)
    }

    if (!isMobile()) {
        console.log('desktop mode');
        $('#w-popup-section').addClass('desktop-mode');
    } else {
        console.log('mobile-mode');
        $('#w-popup-section').removeClass('desktop-mode');
    }
    const keys = [
        "name",
        "phone",
        "email",
        "address",
        "identity",
        "province",
        "district",
        "custom_1",
        "custom_2",
        "custom_3",
        "custom_4",
        "custom_5",
        "custom_6",
        "custom_7",
        "custom_8",
        "custom_9",
        "password",
    ];
    const fields = [];
    for (var key of keys) {
        if (!form[key] || !form[key].enabled) continue;
        form[key].key = key;
        fields.push(form[key]);
    }

    function createForm($form, form) {
        for (var field of form) {
            const inputTag = parseInputTag(field);
            $form.append(`<div class="w-form-group floating ${field.key}">
                    <div class="d-flex align-center">
                        <img class="icon-form" src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/calendar.png">
                        ${inputTag}
                        ${field.required ? '<span class="w-required">*</span>' : ""}
                        <div class="w-error-log">Vui lòng nhập đủ thông tin</div>
                    </div>
                </div>`)
            if (field.key == 'phone' && field.enabled) {
                let input = document.querySelector('input[data-filter]');
                let state = {
                    value: input.value,
                    start: input.selectionStart,
                    end: input.selectionEnd,
                    pattern: RegExp('^' + input.dataset.filter + '$')
                };

                input.addEventListener('input', event => {
                    if (state.pattern.test(input.value)) {
                        state.value = input.value;
                    } else {
                        input.value = state.value;
                        input.setSelectionRange(state.start, state.end);
                    }
                });

                input.addEventListener('keydown', event => {
                    state.start = input.selectionStart;
                    state.end = input.selectionEnd;
                });
            }
            if (field.key == 'name' && field.enabled) {
                $('.w-form-group.name .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/user.png');
            }
            if (field.key == 'phone' && field.enabled) {
                $('.w-form-group.phone .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/smartphone.png');
            }
            if (field.key == 'email' && field.enabled) {
                $('.w-form-group.email .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/mail.png');
            }
            if (field.key == 'address' && field.enabled) {
                $('.w-form-group.address .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/map-pin.png');
            }
            if (field.key == 'province' && field.enabled) {
                $('.w-form-group.province .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/map-pin.png');
            }
            if (field.key == 'district' && field.enabled) {
                $('.w-form-group.district .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/map-pin.png');
            }
            if (field.key == 'identity' && field.enabled) {
                $('.w-form-group.email .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.4/images/icon.png');
            }
            $('.w-form-group label').each(function () {
                var textSize = $(this).text().length;
                if (textSize > 35) {
                    $(this).addClass('overtype');
                    $(this).parent().addClass('oversize');
                }
            });
        }

        $form.find('input, select')
            .on('focus', function () {
                $(this).parent().removeClass('error');
            })
    }

    function parseInputTag(field) {
        if (field.type != 'select') {
            const type = getInputType(field.key);
            if (field.key == 'phone') {
                return `<input 
                type="${type}" placeholder="Vui lòng nhập ${field.name}" data-filter='([\+]|([\+][1-9])?[0-9]*)'
                class="w-${field.key}" name="${field.key}" 
                data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
            }
            return `<input 
                type="${type}" placeholder="Vui lòng nhập ${field.name}"
                class="w-${field.key}" name="${field.key}" 
                data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
        }

        // SELECT
        let html = `<select class="w-form-control w-${field.key}" data-name="${field.name}" name="${field.key}"
            ${field.required ? "required" : ""}/>`;
        if (field.key !== 'province' && field.key !== 'district') {
            if (field.options) {
                html += `<option value=""></option>`;
                var options = field.options.split(',');
                options.forEach(function (option) {
                    html += `<option value="${option}">${option}</option>`
                })
            }
        }
        html += '</select>';
        return html;
    }

    function validateForm(formId) {
        let error = false;

        $(`#${formId} input, #${formId} select`).each((i, e) => {
            $(e).data('error', '');
            $(e).parent().removeClass('error');
            if ($(e).val()) {
                var curVal = $(e).val().toString().trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
            }
            if (!curVal && $(e)[0].required) {
                let action = 'nhập';
                if ($(e)[0].tagName === 'SELECT') {
                    action = 'chọn';
                }
                $(e).parent().addClass('error');
                error = `Vui lòng ${action} ${$(e).data('name')}`;
                $(e).siblings('.w-error-log').html(error);
                $(e).data('error', error);
                return error;
            }
        })
        return error
    }

    function getInputType(k) {
        if (k == 'phone' || k == 'tel') return 'tel';
        if (k == 'email') return 'email';
        if (k == 'number') return 'number';
        return 'text';
    }

    createForm($('#w-popup-section').find('[w-role=form]'), fields);


    // TODO: Move ra chỗ khác
    var submit_btn = SETTINGS.submit_btn || {};
    var button_1 = SETTINGS.btn_1 || {};
    var button_2 = SETTINGS.btn_2 || {};
    $('.voucher-content').append(SETTINGS.voucher_apply);

    $('#w-btn-left').html(button_1.title)
        .css({
            'color': button_1.title,
            'background-color': button_1.background,
            'display': button_1.active ? 'block' : 'none'
        })
        .attr('href', button_1.url);
    $('#w-btn-right').html(button_2.title)
        .css({
            'color': button_2.color,
            'background-color': button_2.background,
            'display': button_2.active ? 'block' : 'none'
        })
        .attr('href', button_2.url);


    if (SETTINGS.logo) {
        $('.award-image').each(function (index, image) {
            $(image).attr('src', SETTINGS.logo);
        })
    }
    $('#w-popup-container').css('background-color', SETTINGS.background_color);
    $('#w-popup-userinfo-form-submit-btn').html(submit_btn.title).css({
        'color': submit_btn.color,
        'background-color': submit_btn.background
    });

    $('.w-popup-close-btn').on('click', closePopup);
    $('.w-close-popup-desktop').on('click', closePopup);
    $('.w-popup-remove-anim').on('click', function () {
        hideAnimWoay();
        $('#w-popup-userinfo-form-submit-btn').removeClass('disable');
    });
    $('#w-popup-close').on('click', closePopup);

    setTimeout(() => {
        html.addLocationDataIntoForm(Wheel);
    }, 100)

    function closePopup() {
        $('#w-popup-section').css({
            'opacity': 0,
            'visibility': 'hidden'
        })
        $('#w-popup-container').css('left', '-200%');
        $('#w-popup-close').css('display', 'none');
        $('.sound-control').css('display', 'none');
        sound.muteAll();
        eventBus.emit('popup-close');
    }

    function isMobile() {
        if (window.innerWidth >= 991) {
            console.log('false');
            return false;
        }
        console.log('true');
        return true;
    }


    function openPopup() {
        $('#w-popup-section').css({
            'opacity': 1,
            'visibility': 'visible',
            'display': 'block'
        })
        $('#w-popup-container').css('left', 0);
        $('#w-popup-close').css('display', 'block');
        $('.sound-control').css('display', 'block');
        sound.unMuteAll();
    }

    function showReward() {
        console.log('showReward');
        $('#w-popup-userinfo-form').css({
            'display': 'none',
            'visibility': 'hidden'
        })
        $('#w-popup-reward').css({
            'display': 'block',
            'visibility': 'visible'
        })
    }

    function hideReward() {
        $('#w-popup-reward').css({
            'display': 'none',
            'visibility': 'hidden'
        })
        $('#w-popup-userinfo-form').css({
            'display': 'block',
            'visibility': 'visible'
        })
    }

    function addAnimWoay() {
        if (isMobile()) {
            $('#w-popup-container').addClass('anim-woay');
            $('#w-popup-container .w-popup-close-btn').css('display', 'none');
            $('#w-popup-container .w-popup-remove-anim').css('display', 'block');
        }
    }

    function hideAnimWoay() {
        if (isMobile()) {
            $('#w-popup-container').removeClass('anim-woay');
            $('#w-popup-container .w-popup-close-btn').css('display', 'block');
            $('#w-popup-container .w-popup-remove-anim').css('display', 'none');
        }
    }

    function playSound() {
        sound.unMuteAll();
    }
    return {
        close: closePopup,
        open: openPopup,
        showReward,
        hideReward,
        addAnimWoay,
        hideAnimWoay,
        validateForm,
        sound,
        playSound,
        eventBus
    }
}